import MobileCategoryQuestions from './MobileCategoryQuestions';

export default MobileCategoryQuestions;
